export default __webpack_public_path__ + "static/media/platinum.eac9a613.svg";